const SDK_VERSION = '7.60.0';

export { SDK_VERSION };
//# sourceMappingURL=version.js.map
